import { render } from "./TrainerCertification.vue?vue&type=template&id=34463e94&scoped=true"
import script from "./TrainerCertification.vue?vue&type=script&lang=js"
export * from "./TrainerCertification.vue?vue&type=script&lang=js"

import "./TrainerCertification.vue?vue&type=style&index=0&id=34463e94&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34463e94"]])

export default __exports__